import { Box, Typography, useTheme } from '@mui/material';

const VALUES = [
  {
    title: 'Simplification:',
    description: 'Create efficiency by simplifying the things we do in a clear and resourceful way',
  },
  {
    title: 'Excellence:',
    description: 'Strive to be the best in everything we do on a global stage',
  },
  {
    title: 'Adaptability:',
    description: 'Approach change with agility and optimism',
  },
];

export default function ValuesBanner() {
  const theme = useTheme();

  return (
    <Box
      component="section"
      sx={{
        mt: 0,
        mb: 3,
        pt: 0,
        pb: 2,
      }}
    >
      <Typography
        variant="h6"
        component="h2"
        sx={{
          fontWeight: 700,
          textAlign: 'center',
          textTransform: 'uppercase',
          letterSpacing: '0.05em',
          color: 'primary.main',
          mb: 3,
        }}
      >
        What we value
      </Typography>
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'nowrap',
          gap: 2,
        }}
      >
        {VALUES.map((value) => (
          <Box
            key={value.title}
            sx={{
              flex: '1 1 0',
              minWidth: 0,
              borderRadius: 2,
              p: 2.5,
              backgroundColor: 'background.paper',
              color: 'text.primary',
              boxShadow: theme.shadows[2],
              borderLeft: '4px solid',
              borderColor: 'primary.main',
            }}
          >
            <Typography variant="subtitle1" component="h3" fontWeight={700} color="primary" sx={{ mb: 0.75 }}>
              {value.title}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.5 }}>
              {value.description}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
